import { lazy } from 'react';

const EmailCaptureHeader = import(
  'components/direct-sales/email-capture/components/EmailCaptureHeader'
);
const EmailCaptureContent = import(
  'components/direct-sales/email-capture/components/EmailCaptureContent'
);
const EmailCaptureRightSidebar = import(
  'components/direct-sales/email-capture/components/EmailCaptureRightSidebar'
);
const EmailCaptureFooter = import(
  'components/direct-sales/email-capture/components/EmailCaptureFooter'
);

export const EmailCapture = {
  Header: lazy(() => EmailCaptureHeader),
  Content: lazy(() => EmailCaptureContent),
  RightSidebar: lazy(() => EmailCaptureRightSidebar),
  Footer: lazy(() => EmailCaptureFooter)
};

export default EmailCapture;